import { Select, SelectProps } from '@chakra-ui/react';
import { FeatureVisibility } from '@snap-types/models/enums';
import { forwardRef } from 'react';

export const FeatureVisibleSelect = forwardRef<HTMLInputElement, SelectProps>(
  (props, ref) => {
    return (
      <Select {...props} ref={ref}>
        <option value={FeatureVisibility.NONE}>No One</option>
        <option value={FeatureVisibility.SUPER_ADMIN}>Super Admins Only</option>
        <option value={FeatureVisibility.ALL}>All Users</option>
      </Select>
    );
  },
);
